import { AuditDashboardResponse, AuditEventStored, AuditAlert, PoliticaRetencao, AuditExpurgoResponse } from '../models/auditoria.model';

export const AUDIT_DASHBOARD_MOCK: AuditDashboardResponse = {
  timeline: [
    { date: '2026-06-09', count: 184 },
    { date: '2026-06-10', count: 242 },
    { date: '2026-06-11', count: 310 },
    { date: '2026-06-12', count: 295 },
    { date: '2026-06-13', count: 85 }, // Fim de semana
    { date: '2026-06-14', count: 92 }, // Fim de semana
    { date: '2026-06-15', count: 412 }  // Hoje
  ],
  topUsers: [
    { matricula: '900.124-A', count: 145 },
    { matricula: '912.854-C', count: 98 },
    { matricula: '882.115-F', count: 87 },
    { matricula: '874.552-H', count: 64 },
    { matricula: '921.341-X', count: 52 },
    { matricula: '899.771-K', count: 43 },
    { matricula: '905.332-M', count: 38 },
    { matricula: '881.002-L', count: 33 },
    { matricula: '862.991-P', count: 25 },
    { matricula: '915.221-D', count: 19 }
  ],
  topResources: [
    { resource: 'ficha-cadastral', count: 320 },
    { resource: 'ficha-medica', count: 245 },
    { resource: 'processo-disciplinar', count: 188 },
    { resource: 'calculo-tempo', count: 142 },
    { resource: 'folha-pagamento', count: 98 },
    { resource: 'requerimento-afastamento', count: 84 },
    { resource: 'simulacao-qode', count: 76 },
    { resource: 'ata-presenca-taf', count: 52 },
    { resource: 'pdi-autoavaliacao', count: 41 },
    { resource: 'boletim-homologacao', count: 33 }
  ],
  distributionByDomain: [
    { domain: 'cadastro', count: 450 },
    { domain: 'saude', count: 310 },
    { domain: 'disciplinar', count: 220 },
    { domain: 'pagamento', count: 180 },
    { domain: 'tempo-servico', count: 150 },
    { domain: 'afastamento', count: 120 },
    { domain: 'organizacao', count: 90 },
    { domain: 'aptidao-fisica', count: 60 }
  ],
  distributionByAction: [
    { action: 'VIEW', count: 820 },
    { action: 'CREATE', count: 240 },
    { action: 'UPDATE', count: 380 },
    { action: 'DELETE', count: 18 },
    { action: 'EXPORT', count: 95 },
    { action: 'PRINT', count: 27 }
  ]
};

export const AUDIT_EVENTS_MOCK: AuditEventStored[] = [
  {
    id: 'f81d4fae-7dec-11d0-a765-00a0c91e6bf6',
    action: 'VIEW',
    domain: 'saude',
    resource: 'ficha-medica',
    resourceId: '900.124-A',
    details: {
      motivoConsulta: 'Inspeção de Saúde Anual obrigatória para TAF',
      camposAcessados: ['anamnese', 'laudo-psicologico', 'restricoes-medicas']
    },
    timestamp: '2026-06-15T10:00:15Z',
    matricula: '912.854-C',
    unidade: 'Diretoria de Saúde (DS)',
    ip: '10.112.4.52',
    userAgent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36',
    receivedAt: '2026-06-15T10:00:16Z'
  },
  {
    id: 'f81d4fae-7dec-11d0-a765-00a0c91e6bf7',
    action: 'UPDATE',
    domain: 'cadastro',
    resource: 'policial',
    resourceId: '882.115-F',
    details: {
      antes: {
        endereco: 'QNL 12 Bloco C AP 302, Taguatinga',
        telefone: '(61) 98888-1111'
      },
      depois: {
        endereco: 'SQS 214 Bloco K AP 101, Asa Sul',
        telefone: '(61) 99999-2222'
      },
      camposAlterados: ['endereco', 'telefone']
    },
    timestamp: '2026-06-15T09:42:30Z',
    matricula: '900.124-A',
    unidade: 'Diretoria de Gestão de Pessoal (DGP)',
    ip: '10.112.2.14',
    userAgent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7)',
    receivedAt: '2026-06-15T09:42:31Z'
  },
  {
    id: 'f81d4fae-7dec-11d0-a765-00a0c91e6bf8',
    action: 'EXPORT',
    domain: 'pagamento',
    resource: 'folha-pagamento',
    resourceId: 'folha-2026-05',
    details: {
      tipoExportacao: 'PDF',
      motivo: 'Auditoria de Rubricas de Adicional de Titularidade',
      linhasExportadas: 142
    },
    timestamp: '2026-06-15T08:15:00Z',
    matricula: '882.115-F',
    unidade: 'Diretoria de Finanças (DF)',
    ip: '10.112.10.85',
    userAgent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) Chrome/121.0.0.0',
    receivedAt: '2026-06-15T08:15:02Z'
  },
  {
    id: 'f81d4fae-7dec-11d0-a765-00a0c91e6bf9',
    action: 'DELETE',
    domain: 'disciplinar',
    resource: 'processo-disciplinar',
    resourceId: 'sei-00054-000123/2025-11',
    details: {
      justificativa: 'Exclusão física determinada por decisão judicial nos autos do Mandado de Segurança nº 071234-56.2025.8.07.0001',
      autorizador: 'Corregedor Geral - PMDF'
    },
    timestamp: '2026-06-15T07:30:12Z',
    matricula: '874.552-H',
    unidade: 'Corregedoria Geral (CG)',
    ip: '10.112.1.8',
    userAgent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) Firefox/122.0',
    receivedAt: '2026-06-15T07:30:15Z'
  },
  {
    id: 'f81d4fae-7dec-11d0-a765-00a0c91e6c00',
    action: 'CREATE',
    domain: 'organizacao',
    resource: 'simulacao-qode',
    resourceId: 'sim-qode-2026-01',
    details: {
      nomeCenario: 'Reestruturação do Comando de Policiamento Metropolitano',
      upmsAfetadas: ['CPM', '1º BPM', '6º BPM'],
      impactoVagasEstimado: 24
    },
    timestamp: '2026-06-14T23:15:00Z',
    matricula: '921.341-X',
    unidade: 'Comando de Policiamento Metropolitano (CPM)',
    ip: '177.85.12.33', // IP Externo (Anomalia potencial)
    userAgent: 'Mozilla/5.0 (iPhone; CPU iPhone OS 17_3_1 like Mac OS X)',
    receivedAt: '2026-06-14T23:15:05Z'
  },
  {
    id: 'f81d4fae-7dec-11d0-a765-00a0c91e6c01',
    action: 'VIEW',
    domain: 'saude',
    resource: 'laudo-psicologico',
    resourceId: '900.124-A',
    details: {
      finalidade: 'Avaliação para porte de arma de fogo institucional',
      statusLaudo: 'Apto com Restrição Temporária'
    },
    timestamp: '2026-06-14T15:10:45Z',
    matricula: '912.854-C',
    unidade: 'Diretoria de Saúde (DS)',
    ip: '10.112.4.91',
    userAgent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) Edge/121.0.0.0',
    receivedAt: '2026-06-14T15:10:48Z'
  },
  {
    id: 'f81d4fae-7dec-11d0-a765-00a0c91e6c02',
    action: 'UPDATE',
    domain: 'disciplinar',
    resource: 'processo-disciplinar',
    resourceId: 'sei-00054-000998/2024-52',
    details: {
      antes: {
        faseProcesso: 'Instrução',
        membrosComissao: ['Cap. Albuquerque', 'Ten. Mendes']
      },
      depois: {
        faseProcesso: 'Julgamento',
        membrosComissao: ['Cap. Albuquerque', 'Ten. Mendes', 'Ten. Costa']
      },
      camposAlterados: ['faseProcesso', 'membrosComissao']
    },
    timestamp: '2026-06-13T11:20:00Z',
    matricula: '874.552-H',
    unidade: 'Corregedoria Geral (CG)',
    ip: '10.112.1.12',
    userAgent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64)',
    receivedAt: '2026-06-13T11:20:02Z'
  },
  {
    id: 'f81d4fae-7dec-11d0-a765-00a0c91e6c03',
    action: 'PRINT',
    domain: 'tempo-servico',
    resource: 'calculo-tempo',
    resourceId: '899.771-K',
    details: {
      finalidade: 'Instrução de processo de Reserva Remunerada',
      anosAverbados: 8.5
    },
    timestamp: '2026-06-12T17:40:19Z',
    matricula: '899.771-K',
    unidade: 'Seção de Inativos e Pensionistas (SIP)',
    ip: '10.112.5.15',
    userAgent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) Chrome/121.0.0.0',
    receivedAt: '2026-06-12T17:40:22Z'
  }
];

// Gerar mais logs de auditoria fictícios para paginação
for (let i = 9; i <= 50; i++) {
  const actions: ('VIEW' | 'CREATE' | 'UPDATE' | 'DELETE' | 'EXPORT' | 'PRINT')[] = ['VIEW', 'UPDATE', 'CREATE', 'EXPORT'];
  const domains = ['cadastro', 'saude', 'disciplinar', 'pagamento', 'tempo-servico'];
  const selectedAction = actions[i % actions.length];
  const selectedDomain = domains[i % domains.length];
  
  AUDIT_EVENTS_MOCK.push({
    id: `f81d4fae-7dec-11d0-a765-00a0c91e6c${i.toString(16).padStart(2, '0')}`,
    action: selectedAction,
    domain: selectedDomain,
    resource: `recurso-${selectedDomain}-${i}`,
    resourceId: `res-id-${i * 100}`,
    details: {
      info: `Descrição automatizada do log nº ${i}`,
      operacaoEfetuada: `Log de testes de carga paginada ${i}`
    },
    timestamp: `2026-06-${(15 - Math.floor(i/4)).toString().padStart(2, '0')}T12:00:00Z`,
    matricula: `900.${100 + i}-X`,
    unidade: 'Diretoria de Tecnologia e Informação (DITEL)',
    ip: `10.112.8.${i}`,
    userAgent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) Chrome/122.0.0.0',
    receivedAt: `2026-06-${(15 - Math.floor(i/4)).toString().padStart(2, '0')}T12:00:05Z`
  });
}

export const AUDIT_ALERTS_MOCK: AuditAlert[] = [
  {
    id: 'a11d4fae-7dec-11d0-a765-00a0c91e6bf0',
    type: 'UNUSUAL_HOURS',
    description: 'Acesso realizado fora do expediente normal (02:14h) a dados de saúde restritos.',
    severity: 'HIGH',
    matricula: '912.854-C',
    timestamp: '2026-06-15T02:14:10Z',
    resolved: false
  },
  {
    id: 'a11d4fae-7dec-11d0-a765-00a0c91e6bf1',
    type: 'ANOMALOUS_VOLUME',
    description: 'Exportação de 142 relatórios de folha de pagamento na mesma sessão (limite usual: 10).',
    severity: 'HIGH',
    matricula: '882.115-F',
    timestamp: '2026-06-15T08:16:05Z',
    resolved: false
  },
  {
    id: 'a11d4fae-7dec-11d0-a765-00a0c91e6bf2',
    type: 'REPEATED_ACCESS',
    description: 'Acesso repetitivo (32 vezes em 5 min) à ficha médica do mesmo militar alvo de sindicância.',
    severity: 'MEDIUM',
    matricula: '912.854-C',
    timestamp: '2026-06-14T10:12:00Z',
    resolved: false
  },
  {
    id: 'a11d4fae-7dec-11d0-a765-00a0c91e6bf3',
    type: 'UNUSUAL_HOURS',
    description: 'Tentativa de exclusão física de registro disciplinar às 23:30h de um sábado.',
    severity: 'HIGH',
    matricula: '874.552-H',
    timestamp: '2026-06-13T23:30:12Z',
    resolved: true,
    resolvedBy: '990.221-X',
    resolvedAt: '2026-06-14T08:00:00Z'
  },
  {
    id: 'a11d4fae-7dec-11d0-a765-00a0c91e6bf4',
    type: 'REPEATED_ACCESS',
    description: 'Visualização da ficha cadastral de 15 pessoas em sequência de matrículas proximas.',
    severity: 'LOW',
    matricula: '900.124-A',
    timestamp: '2026-06-12T14:25:00Z',
    resolved: true,
    resolvedBy: '990.221-X',
    resolvedAt: '2026-06-12T15:30:00Z'
  },
  {
    id: 'a11d4fae-7dec-11d0-a765-00a0c91e6bf5',
    type: 'UNUSUAL_HOURS',
    description: 'Acesso às folhas de pagamento às 22:50 do domingo.',
    severity: 'MEDIUM',
    matricula: '882.115-F',
    timestamp: '2026-06-11T22:50:00Z',
    resolved: false
  }
];

export const POLITICAS_RETENCAO_MOCK: PoliticaRetencao[] = [
  {
    id: 'p11d4fae-7dec-11d0-a765-00a0c91e6c10',
    domain: 'saude',
    periodoDias: 3650, // 10 anos (Dado Sensível)
    requerAprovacaoDpo: true,
    ativo: true
  },
  {
    id: 'p11d4fae-7dec-11d0-a765-00a0c91e6c11',
    domain: 'disciplinar',
    periodoDias: 3650, // 10 anos (Dado Sensível)
    requerAprovacaoDpo: true,
    ativo: true
  },
  {
    id: 'p11d4fae-7dec-11d0-a765-00a0c91e6c12',
    domain: 'cadastro',
    periodoDias: 1825, // 5 anos
    requerAprovacaoDpo: false,
    ativo: true
  },
  {
    id: 'p11d4fae-7dec-11d0-a765-00a0c91e6c13',
    domain: 'pagamento',
    periodoDias: 1825, // 5 anos
    requerAprovacaoDpo: false,
    ativo: true
  },
  {
    id: 'p11d4fae-7dec-11d0-a765-00a0c91e6c14',
    domain: 'afastamento',
    periodoDias: 1825,
    requerAprovacaoDpo: false,
    ativo: true
  }
];

export const AUDIT_EXPURGO_MOCK: AuditExpurgoResponse = {
  deletedCount: 1542,
  timestamp: '2026-06-15T13:00:00Z',
  details: [
    { domain: 'cadastro', count: 841 },
    { domain: 'pagamento', count: 501 },
    { domain: 'afastamento', count: 200 }
  ]
};
